import { render, staticRenderFns } from "./SquareThumbnail.vue?vue&type=template&id=411151ec&scoped=true&"
import script from "./SquareThumbnail.vue?vue&type=script&lang=js&"
export * from "./SquareThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./SquareThumbnail.vue?vue&type=style&index=0&id=411151ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411151ec",
  null
  
)

export default component.exports